<template>
  <div class="banner">
    <!-- 查询和删除操作 -->
    <el-form :inline="true" :model="queryBannerList">
      <!-- <el-form-item>
                <el-cascader
                    v-model="queryInfo.channelNo"
                    :options="channelTree"
                    :show-all-levels="false"
                    clearable
                    :props="optionsTree"
                ></el-cascader>
            </el-form-item> -->
      <!-- 根据生效时间查询 -->
      <!-- <el-form-item>
                <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="queryBannerList.startTime"
                    type="date"
                    width="60"
                    placeholder="开始时间"
                >
                </el-date-picker>
            </el-form-item> -->
      <!-- <el-form-item>
                <el-date-picker
                    value-format="yyyy-MM-dd"
                    v-model="queryBannerList.endTime"
                    type="date"
                    width="100"
                    placeholder="结束时间"
                >
                </el-date-picker>
            </el-form-item> -->
      <el-form-item>
        <el-input
          v-model="queryBannerList.title"
          placeholder="请输入标题"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getBannerList(1)">查询</el-button>
        <el-button @click="addOrUpdateHandle">新增</el-button>
        <el-button
          type="danger"
          @click="multipleDelete()"
          :disabled="selectDelete.length <= 0"
          >批量删除
        </el-button>
        <el-button type="warning" @click="chongzhi">重置 </el-button>
      </el-form-item>
    </el-form>
    <!-- banner信息展示 -->
    <el-table
      :data="bannerListArr"
      style="width: 100%"
      border
      @selection-change="handleSelectionChange"
      :default-sort="{ prop: 'sort', order: 'descending' }"
      v-loading="loading"
    >
      <el-table-column type="index" width="50" label="#" align="center">
      </el-table-column>
      <el-table-column type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        align="center"
        min-width="350"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-link
            :href="scope.row.linkUrl"
            target="_blank"
            :underline="false"
            >{{ showContent(scope.row.title) }}</el-link
          >
        </template>
      </el-table-column>
      <!-- <el-table-column
                prop="description"
                label="banner描述"
                align="center"
                width="180"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    {{showContent(scope.row.description)}}
                </template>
            </el-table-column> -->
      <el-table-column
        prop="imageUrl"
        label="banner图片"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <div class="img-show">
            <el-image
              v-if="scope.row.imageUrl != null"
              width="75%"
              contain
              class="image-slot"
              :src="scope.row.imageUrl"
              :preview-src-list="[scope.row.imageUrl]"
              fit="cover"
            ></el-image>
            <div v-else slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column
                prop="channelNo"
                label="渠道号"
                align="center"
                width="170"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <span>
                        {{ channelListObj[scope.row.channelNo] }}
                    </span>
                </template>
            </el-table-column> -->
      <el-table-column prop="type" label="类型" align="center" width="80">
        <template slot-scope="">
          <!-- <span>
            {{ calcType(scope.row.type) }}
          </span> -->
          <span> 外链 </span>
        </template>
      </el-table-column>
      <el-table-column prop="showStatus" label="状态" align="center" width="80">
        <template slot-scope="scope">
          <el-button
            size="mini"
            :type="scope.row.showStatus === '0' ? 'danger' : 'success'"
            class="padding-style"
            @click="changeShow(scope.row)"
            plain
          >
            {{ scope.row.showStatus === "0" ? "不显示" : "显示" }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="checkStatus"
        label="审核状态"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            plain
            class="padding-style"
            :type="checkStyle(scope.row.checkStatus)"
            @click="examineStatus(scope.row)"
          >
            {{ checkShow(scope.row.checkStatus) }}
          </el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column
                prop="startTime"
                label="开始时间"
                width="110"
                align="center"
            >
            </el-table-column> -->
      <!-- <el-table-column
                prop="endTime"
                label="结束时间"
                width="110"
                align="center"
            >
            </el-table-column>
            <el-table-column
                prop="createTime"
                label="创建时间"
                width="110"
                align="center"
            >
            </el-table-column>
            <el-table-column
                align="center"
                prop="updateTime"
                label="更新时间"
                width="110"
            >
            </el-table-column> -->
      <!-- <el-table-column prop="sort" label="排序" align="center" width="70">
        <template slot-scope="scope">
          <el-input
            class="ee-input"
            v-model.number="scope.row.sort"
            @blur="updateSort(scope.row)"
          ></el-input>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="addOrUpdateHandle(scope.row)"
          >
            修改
          </el-button>
          <el-button type="text" size="small" @click="deleteBanner(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @bannersUpdateList="bannersUpdateList"
      :checked-banner="checkedBanner"
      :channel-tree="channelTree"
    ></add-or-update>
    <!-- 审核新添加列表的弹框 -->
    <check-status
      :check-query="checkQuery"
      ref="checkRef"
      @updateComputed="getBannerList()"
    />
    <!-- banner分页器 -->
    <el-pagination
      background
      layout="total,prev, pager, next"
      :total="bannerTotal"
      @current-change="pageChange"
      :page-size="queryBannerList.limit"
      :current-page="queryBannerList.currentPage"
    >
    </el-pagination>
  </div>
</template>

<script>
import AddOrUpdate from "@/views/modules/config/child-components/banner-add-or-update";
import CheckStatus from "@/views/modules/config/child-components/check-status";
import { showcontent } from "@/utils/method.js";
export default {
  components: {
    AddOrUpdate,
    CheckStatus,
  },
  data() {
    return {
      // 请求banner列表的参数
      queryBannerList: {
        limit: 10,
        page: 1,
        channelNo: "",
        startTime: "",
        endTime: "",
        title: "",
      },
      // banner展示列表数据
      bannerListArr: [],
      // banner的总数
      bannerTotal: 0,
      // 查询参数
      queryInfo: {
        channelNo: "",
      },
      // banner类别列表
      channelList: [],
      channelListObj: {},
      // 控制新增修改弹窗的显示与隐藏
      addOrUpdateVisible: false,
      // 批量选中待删除的数组
      selectDelete: [],
      // 审核状态参数
      checkQuery: {
        id: null,
        checkStatus: "1",
      },
      // 被选中修改的banner数据
      checkedBanner: {},

      // 加载组件的显示与隐藏
      loading: false,
      // channel的树形结构
      channelTree: [],
      // 级联选择框的配置
      optionsTree: {
        label: "channelName",
        value: "channelNo",
        checkStrictly: true,
        emitPath: false,
      },
    };
  },
  created() {
    this.getBannerList();
    this.getchannelType();
  },
  computed: {
    // 计算banner的所属类型
    calcType() {
      return (type) => {
        return type === "1"
          ? "外链"
          : type === "2"
          ? "新闻"
          : type === "3"
          ? "活动"
          : "课程";
      };
    },
    // 审核状态样式计算
    checkStyle() {
      return (status) => {
        return status === "0" ? "info" : status === "1" ? "success" : "danger";
      };
    },
    // 审核状态文字显示计算
    checkShow() {
      return (status) => {
        return status === "0"
          ? "待审核"
          : status === "1"
          ? "审核通过"
          : "审核不通过";
      };
    },
    //将标题和描述进行两次转义
    showContent() {
      return (item) => {
        return showcontent(showcontent(item));
      };
    },
  },
  methods: {
    chongzhi() {
      // 请求banner列表的参数
      this.queryBannerList = {
        limit: 10,
        page: 1,
        channelNo: "",
        startTime: "",
        endTime: "",
        title: "",
      };
      this.$nextTick(() => {
        this.getBannerList();
      });
    },
    // 获取banner列表
    getBannerList(id) {
      id == 1 ? (this.queryBannerList.page = 1) : "";
      this.loading = true;
      this.$ajaxPost("/banner/list", this.queryBannerList).then(({ data }) => {
        this.loading = false;
        if (data.code === 0) {
          const { list, totalCount } = data.data;
          this.bannerListArr = list;
          this.bannerTotal = totalCount;
        }
        if (data.code === 500) {
          this.bannerListArr = [];
          this.bannerTotal = 0;
        }
      });
    },

    // 分页器页数改变时触发事件
    pageChange(val) {
      this.queryBannerList.page = val;
      this.getBannerList();
    },
    // 新增 / 修改
    addOrUpdateHandle(item) {
      this.addOrUpdateVisible = true;
      if (item) {
        this.checkedBanner = item;
        this.$nextTick(() => {
          this.$refs.addOrUpdate.init(item.id);
        });
      } else {
        this.$nextTick(() => {
          this.$refs.addOrUpdate.init();
        });
      }
    },
    // 新增或修改时重新请求列表数据
    bannersUpdateList() {
      this.getBannerList();
    },

    // 根据有效期时段进行查询
    searchByValid() {
      this.getBannerListByTime();
    },
    // 点击复选框时触发事件
    handleSelectionChange(val) {
      this.selectDelete = val;
    },
    // 排序框失去焦点时保存排序
    updateSort(item) {
      const { id, sort } = item;
      this.$ajaxPost("/banner/update", { id, sort }).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success("排序更新成功");
        }
      });
    },
    //批量删除banner列表
    multipleDelete() {
      let ids = [];
      for (let i = 0; i < this.selectDelete.length; i++) {
        ids.push(this.selectDelete[i].id + "");
      }

      this.$confirm("确定要批量删除banner数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$ajaxPost("/banner/deleteBatch", ids)
          .then(({ data }) => {
            if (data.code === 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getBannerList();
              this.selectDelete = [];
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "删除失败，请联系管理员",
            });
          });
      });
    },
    // 打开审核新添加的banner弹框事件
    examineStatus(id) {
      this.checkQuery.id = id.id;
      if (id.checkStatus == 0) {
        this.checkQuery.checkStatus = "1";
      } else {
        this.checkQuery.checkStatus = id.checkStatus;
      }
      this.$nextTick(() => {
        this.$refs.checkRef.init("/banner/update");
      });
    },

    // 删除单个banner列表
    deleteBanner(item) {
      this.$confirm("此操作将永久删除该条目,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const { channelNo, id } = item;
          let ids = [id];
          let { data } = await this.$ajaxPost("/banner/deleteBatch", ids, {
            channelNo,
          });
          if (data.code === 0) {
            this.getBannerList();
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // channelNo改变时触发事件
    channelChange() {
      this.queryBannerList.page = 1;
      this.getBannerList();
    },
    getchannelType() {
      this.$ajaxGet("/channel/list/open").then(({ data }) => {
        this.channelTree = data.data;
        let arr = [];
        this.channelList = this.recursion(data.data, arr);
        this.transformChannel();
      });
    },
    // 从channel转化为对象
    transformChannel() {
      let obj = {},
        arr = [];

      if (this.channelList.length) {
        this.channelList.forEach((item) => {
          obj[item.id] = item.name;
        });
      }
      this.channelListObj = obj;
    },
    // 递归遍历数组获取children
    recursion(arr, newArr) {
      if (!arr) return;
      for (let i = 0; i < arr.length; i++) {
        let obj = { name: arr[i].channelName, id: arr[i].channelNo };
        newArr.push(obj);
        if (arr[i].children && arr[i].children.length > 0) {
          this.recursion(arr[i].children, newArr);
        }
      }
      return newArr;
    },
    // 点击显示/不显示按钮
    async changeShow(item) {
      let { id, showStatus } = item;
      showStatus = showStatus === "1" ? "0" : "1";
      const { data } = await this.updateState({ id, showStatus });
      if (data.code === 0) {
        item.showStatus = showStatus;
      }
    },
    // 更新赛事活动封装函数
    updateState(queryInfo) {
      return this.$ajaxPost("/banner/update", queryInfo);
    },
    handleChange(val) {
      console.log(val);
    },
  },
};
</script>

<style lang="less" scoped>
.ee-input {
  /deep/.el-input__inner {
    text-align: center;
  }
}
.check-status {
  text-align: center;
}
.img-show {
  display: flex;
  height: 40px;
  width: 100%;
  align-items: center;
  justify-content: center;
}
.padding-style {
  padding: 5px 7px;
}
/deep/.el-icon-circle-close {
  color: white;
}
</style>